import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Address } from "../types/types";

interface GridAreaProps {
  detectedAddresses: [];
}

const GridArea: React.FC<GridAreaProps> = ({ detectedAddresses }) => {
  return (
    <div className="card" style={{ padding: "20px" }} >
      <DataTable
        value={detectedAddresses}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
      >
        <Column field="VAT" header="VAT" style={{ width: "10%" }}></Column>
        <Column field="Name" header="Name" style={{ width: "20%" }}></Column>
        <Column
          field="Address"
          header="Address"
          style={{ width: "20%" }}
        ></Column>
        <Column
          field="Zip_Code"
          header="Zip Code"
          style={{ width: "10%" }}
        ></Column>
        <Column field="City" header="City" style={{ width: "10%" }}></Column>
        <Column field="Phone" header="Phone" style={{ width: "10%" }}></Column>
        <Column field="Email" header="Email" style={{ width: "10%" }}></Column>
        <Column
          field="Employees"
          header="Employees"
          style={{ width: "10%" }}
        ></Column>
      </DataTable>
    </div>
  );
};

export default GridArea;
